<template>
<div class="map_content my_map" :id="id">
  <!-- Fiches placées ici pour qu'elles soient visibles en plein écran -->
  <fiche-lte ref="ficheLte"></fiche-lte>
  <fiche-tnt ref="ficheTnt"></fiche-tnt>
  <modaleCoordonnees ref="modaleCoordonnees" @updateCoords="updateCoords"></modaleCoordonnees>
  <div class="map_tools" style="width: 100%; height: 100%">
    <div class="top_left">
      <search-adresse></search-adresse>
      <div class="coords">
        <p>Latitude : {{coordToDegresSexagesimaux(latitude)}} <span class="space"></span> Longitude : {{coordToDegresSexagesimaux(longitude)}}</p>
        <button class="buttonCoords" @click="$refs['modaleCoordonnees'].openModal()"></button>
      </div>
    </div>

      <div class="outer_center">
        <div class="middle_center">
          <div class="cibleCenter"></div>
        </div>
      </div>
    <div style="display: none;">
      <div id="location-marker" class="location-marker"></div>
    </div>

    <div class="bottom_left">
      <!-- Changer Fonds de carte -->
      <div class="line">
        <div class="bgmaps">
          <button class="change_background" :class="{ planIGN: $store.state.ign=='GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2', planOSM: $store.state.ign=='OPENSTREETMAP.PLANCARTE'}" @click="switchIgnLayer"></button>
        </div>
        <!-- Echelle -->
        <div class="scale">
          <div id="crMapInfo">
            <div id="scaleContainer" />
          </div>
        </div>
      </div>
    </div>
    <div class="bottom_right">
      <div class="action_buttons">
        <button class="geolocation" @click="createNewGeolocation"></button>
        <button class="zoom_plus" @click="zoomPlus"></button>
        <button class="zoom_less" @click="zoomMinus"></button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
/*eslint-disable*/
import SearchAdresse from './SearchAdresse.vue'
import FicheLte from './FicheLte.vue'
import FicheTnt from './FicheTnt.vue'
import ModaleCoordonnees from './ModaleCoordonnees.vue'
import 'ol/ol.css'
import OlMap from 'ol/Map'
import {
  defaults as defaultControls
} from 'ol/control';
import {
  defaults as defaultInteractions
} from 'ol/interaction';
import OlView from 'ol/View'
import OlControlScaleLine from 'ol/control/ScaleLine'
import OlControlFullScreen from 'ol/control/FullScreen'
import * as OlProj from 'ol/proj'
import * as OlExtent from 'ol/extent'
import OlTilegridWMTS from 'ol/tilegrid/WMTS'
import OlSourceWMTS from 'ol/source/WMTS'
import OlLayerTile from 'ol/layer/Tile'
import OlLayerGroup from 'ol/layer/Group'
import * as OlEasing from 'ol/easing'
import GeoJSON from 'ol/format/GeoJSON'
import olPoint from 'ol/geom/Point'
import * as eventTypes from '../../bus/event-types.js'
import EventBus from '../../bus'
import * as OlLoadingstrategy from 'ol/loadingstrategy'
import * as OlFeatureloader from 'ol/featureloader'
import OlSourceVector from 'ol/source/Vector'
import OlSourceCluster from 'ol/source/Cluster'
import OlSourceOSM from 'ol/source/OSM'
import OlLayerVector from 'ol/layer/Vector'
import OlStyleStyle from 'ol/style/Style'
import OlStyleFill from 'ol/style/Fill'
import OlStyleText from 'ol/style/Text'
import OlStyleIcon from 'ol/style/Icon'
import OlOverlay from 'ol/Overlay'
import OlGeolocation from 'ol/Geolocation'
import OlLayerImage from 'ol/layer/Image'
import OlInteractionSelect from 'ol/interaction/Select'
import axios from 'axios'
import _ from 'lodash'
import storeJs from 'store'
export default {
  name: 'OlMap',
  components: {
    SearchAdresse,
    FicheLte,
    FicheTnt,
    ModaleCoordonnees
  },
  props: {
    zoom: {
      required: false,
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      map: {
        type: Object,
        default: {}
      },
      styleCache: {},
      latitude: null,
      longitude: null,
      geolocation: null,
      position: null,
      marker: null,
      centrer:null,
      puissanceEmetteurs: []
    }
  },
  watch: {
    ign() {
      let orthoLayerIGN = this.findLayer('ORTHOIMAGERY.ORTHOPHOTOS')
      let planLayerIGN = this.findLayer('GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2')
      let planLayerOSM = this.findLayer('OPENSTREETMAP.PLANCARTE')
      let currentLayer = this.$store.state.ign
      orthoLayerIGN.setVisible(currentLayer === orthoLayerIGN.get('layerName'))
      planLayerIGN.setVisible(currentLayer === planLayerIGN.get('layerName'))
      planLayerOSM.setVisible(currentLayer === planLayerOSM.get('layerName'))
    }
  },
  computed: {
    id() {
      return this.$options.name + '-' + this._uid
    },
    ignKey() {
      return this.$store.state.params.ignKey
    },
    ign() {
      return this.$store.state.ign
    }
  },
  mounted() {
    this.$store.state.menu.active = false
    this.$store.state.footer.active = false
    // Ecoute des événements ouverture de fiches
    EventBus.$on(eventTypes.OPEN_LTE, lte => {
      this.$refs['ficheLte'].loadLte(lte)
    })
    EventBus.$on(eventTypes.OPEN_TNT, tnt => {
      this.$refs['ficheTnt'].loadTnt(tnt, this.hasUnresolvedIncident(tnt.get('incidents')));
    })
    this.map = new OlMap({
      controls: defaultControls({
        rotate: false,
        zoom: false,
        attribution: false,
        attributionOptions: {
          collapsible: false
        }
      }).extend([
        new OlControlScaleLine({
          target: document.getElementById('scaleContainer')
        })
      ]),
      interactions: defaultInteractions({
        altShiftDragRotate: false,
        pinchRotate: false,
        keyboard: false
      }),
      target: this.id,
      layers: [],
      view: new OlView({
        projection: 'EPSG:3857',
        zoom: this.zoom,
        maxZoom: 18,
        minZoom: 2,
        extent: [-Math.PI * 6378137, -Math.PI * 6378137, Math.PI * 6378137, Math.PI * 6378137]
      })
    });
    this.addLayers()
    this.zoomToBestExtent()
    this.addVectorLayers()
    this.addExtentListener();
    
    EventBus.$on(eventTypes.ZOOM_TOGEOM, geom => {
      this.findLayer('Tnt').getSource().getSource().clear();
      this.findLayer('Lte').getSource().getSource().clear();
      this.findLayer('Tnt').getSource().getSource().refresh();
      this.findLayer('Lte').getSource().getSource().refresh();
      this.zoomToGeom(geom)
    });
    var coords = OlProj.transform(this.map.getView().getCenter(), 'EPSG:3857', 'EPSG:4326');
    this.longitude = coords[0];
    this.latitude = coords[1];
    this.addLocationTracker(false);
  },
  beforeDestroy() {
    EventBus.$off(eventTypes.ZOOM_TOGEOM)
    EventBus.$off(eventTypes.OPEN_LTE)
    EventBus.$off(eventTypes.OPEN_TNT)
  },
  methods: {
    tntUrl() {
      var coords = OlProj.transform(this.map.getView().getCenter(), 'EPSG:3857', 'EPSG:4326');
      var lon = coords[0]
      var lat = coords[1]
      storeJs.set('prtv:lon', lon)
      storeJs.set('prtv:lat', lat)
      return '/emetteurtnt' + '?lon=' + lon + '&lat=' + lat + '&rayon=' + this.$store.state.rayonTnt
    },
    lteUrl() {
      var coords = OlProj.transform(this.map.getView().getCenter(), 'EPSG:3857', 'EPSG:4326');
      var lon = coords[0]
      var lat = coords[1]
      return '/emetteurlte' + '?lon=' + lon + '&lat=' + lat + '&rayon=' + this.$store.state.rayonLte
    },
    addLayers() {
      this.addOSMLayers();
      this.addIGNLayers();
    },
    addIGNLayers() {
      this.map.addLayer(this.createCarteLayer())
      this.map.addLayer(this.createPhotoLayer())
    },
    createCarteLayer() {
      return this.createIgnLayer('GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2', 18)
    },
    createPhotoLayer() {
      return this.createIgnLayer('ORTHOIMAGERY.ORTHOPHOTOS', 22)
    },
    createIgnLayer(layerName, maxResolutionNum) {
      var resolutions = []
      var matrixIds = []
      var proj3857 = OlProj.get('EPSG:3857')
      var maxResolution = OlExtent.getWidth(proj3857.getExtent()) / 256
      for (var i = 0; i < maxResolutionNum; i++) {
        matrixIds[i] = i.toString()
        resolutions[i] = maxResolution / Math.pow(2, i)
      }
      var tileGrid = new OlTilegridWMTS({
        origin: [-20037508, 20037508],
        resolutions: resolutions,
        matrixIds: matrixIds
      })
      var format = ''
      if(layerName === 'ORTHOIMAGERY.ORTHOPHOTOS'){
        format = 'image/jpeg'
      } else {
        format = 'image/png'
      }
      var ignSource = new OlSourceWMTS({
        url: 'https://data.geopf.fr/wmts',
        layer: layerName,
        matrixSet: 'PM',
        format: format,
        projection: 'EPSG:3857',
        tileGrid: tileGrid,
        style: 'normal',
        // Pour exporter la map
        crossOrigin: 'anonymous',
        attributions: '<a href="http://www.geoportail.fr/" target="_blank">' + '<img src="https://api.ign.fr/geoportail/api/js/latest/' + 'theme/geoportal/img/logo_gp.gif"></a>',
        wrapX: true
      })
      var layer = new OlLayerTile({
        preload: Infinity,
        layerName: layerName,
        visible: this.ign === layerName,
        source: ignSource,
        opacity: 1 // TODO remove opacity
      })
      return layer
    },
    addOSMLayers() {
      this.map.addLayer(this.createOSMLayer('OPENSTREETMAP.PLANCARTE'))
    },
    createOSMLayer(layerName) {
      return new OlLayerTile({
        source: new OlSourceOSM({
          wrapX: true,
          crossOrigin: 'anonymous',
        }),
        layerName: 'OPENSTREETMAP.PLANCARTE',
        opacity: 1,
        visible: true
      });
    },
    findLayer(code, layers) {
      let returned
      if (!layers) {
        layers = this.map.getLayers()
      }
      layers.forEach(function(layer) {
        if (layer instanceof OlLayerGroup) {
          returned = this.findLayer(code, layer.getLayers())
        } else {
          if (layer.get('layerName') === code) {
            returned = layer
          }
        }
      })
      return returned
    },
    switchIgnLayer() {
      var layer = null;
      switch (this.$store.state.ign) {
        case 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2':
          layer = 'ORTHOIMAGERY.ORTHOPHOTOS';
          break;
        case 'ORTHOIMAGERY.ORTHOPHOTOS':
          layer = 'OPENSTREETMAP.PLANCARTE';
          break;
        case 'OPENSTREETMAP.PLANCARTE':
          layer = 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2'
          break;
      }
      this.$store.dispatch('switchIgnLayer', layer);
    },
    zoomToBestExtent() {
      if (storeJs.get('prtv:lon') && storeJs.get('prtv:lat')) {
        var coords = OlProj.transform([storeJs.get('prtv:lon'), storeJs.get('prtv:lat')], 'EPSG:4326', 'EPSG:3857');
        this.map.getView().setCenter(coords);
      } else {
        let paris = [256805.64470225616, 6249216.947446961, 265705.78118321137, 6252690.054919669]
        this.map.getView().fit(paris)
      }
    },
    centerOnLocation() {
      if (this.position) {
        let currentResolution = this.map.getView().getResolution()
        if (currentResolution > 5) {
          this.map.getView().setResolution(5)
        }
        this.map.getView().setCenter(this.position)
      }
    },
    zoomPlus() {
      this.map.getView().setZoom(this.map.getView().getZoom() + 1)
    },
    zoomMinus() {
      this.map.getView().setZoom(this.map.getView().getZoom() - 1)
    },
    zoomToGeom(geometrie) {
      let geom = new GeoJSON().readGeometry(geometrie.geom, {
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857'
      });
      this.map.getView().fit(geom.getExtent(), {
        minResolution: 1.5
      })
      this.$store.state.lon = geometrie.geom.coordinates[0]
      this.$store.state.lat = geometrie.geom.coordinates[1]
    },
    addVectorLayers() {
      var tntLayer = this.createTntLayer()
      var lteLayer = this.createLteLayer()
      this.map.addLayer(tntLayer)
      this.map.addInteraction(new OlInteractionSelect({
        condition: function(evt) {
          return evt.type === 'pointermove' || evt.type === 'singleclick'
        },
        layers: [tntLayer],
        style: this.tntStyleHover
      }))
      this.map.addLayer(lteLayer)
      this.map.addInteraction(new OlInteractionSelect({
        condition: function(evt) {
          return evt.type === 'pointermove' || evt.type === 'singleclick'
        },
        layers: [lteLayer],
        style: this.lteStyleHover
      }))
      var self = this
      let select = new OlInteractionSelect({
        condition: function(evt) {
          if(evt.target == null){
            return false
          }
          var features = evt.target.getFeaturesAtPixel(evt.pixel)
          var resolution = evt.target.getView().getResolution()
          if ((self.map.getView().getZoom() > 12) && features.length > 1) {
            evt.target.forEachFeatureAtPixel(evt.pixel, function(feature, layer) {
              if (layer.get('layerName') == 'Tnt') {
                var featuret = layer.getSource().getSource().getFeatureById(feature.get('features')[0].id_)
                var extent = featuret.getGeometry().flatCoordinates
                var geom = new olPoint([extent[0] + 30 * resolution, extent[1]])
                featuret.setGeometry(geom)
              }
            });
          }
          return evt.type === 'click'
        },
        layers: [lteLayer, tntLayer]
      });
      select.interactionName = 'showFiche'
      this.map.addInteraction(select)
      var self = this
      select.on('select', function(e) {
        _.forEach(e.selected, feature => {
          let features = feature.get('features')
          _.forEach(features, realFeat => {
            if (realFeat.get("azimut")) {
              self.$refs['ficheLte'].loadLte(realFeat)
            } else if (features.length == 1) { // Pas de clic sur un cluster d'émetteurs TNT
              self.$refs['ficheTnt'].loadTnt(realFeat, self.hasUnresolvedIncident(realFeat.get('incidents')))
            }
            // L'événement doit être déclenché à nouveau pour ouvrir la fiche à nouveau
            // e.target : l'interaction "select"
            e.target.getFeatures().clear()
          })
        })
      }, this)
    },
    tntStyleHover(feature, resolution) {
      return this.tntStylePictos(feature, resolution, true)
    },
    lteStyleHover(feature, resolution) {
      return this.lteStylePictos(feature, resolution, true)
    },
    createTntLayer() {
      let me = this
      let vectorSource = new OlSourceVector({
        format: new GeoJSON(),
        url: this.tntUrl,
        strategy: OlLoadingstrategy.all,
      })
      let clusterSource = new OlSourceCluster({
        distance: 40,
        source: vectorSource
      })
      let layer = new OlLayerVector({
        layerName: 'Tnt',
        source: clusterSource,
        style: this.tntStyle,
        visible: true
      })
      return layer
    },
    tntStyle(feature, resolution) {
      let bigScale = resolution <= 0.000010728836059570312 // TODO voir sur quoi s'appuyer
      var size = feature.get('features').length
      if (bigScale || size < 2) {
        return this.tntStylePictos(feature, resolution, false)
      } else {
        return this.tntStyleCounter(feature, resolution, false)
      }
    },
    tntStylePictos(feature, resolution, hover) {
      let bigScale = resolution <= 0.000010728836059570312 // TODO voir sur quoi s'appuyer
      let url = null
      _.forEach(feature.get('features'), realFeat => {
        if (realFeat.get('plusFort') && !this.hasUnresolvedIncident(realFeat.get('incidents'))) {
          url = '/static/img/features/tnt_green.png'
        } else if (this.hasUnresolvedIncident(realFeat.get('incidents'))) {
          url = '/static/img/features/tnt_red.png';
        } else {
          url = '/static/img/features/tnt_blue.png'
        }
      })
      let cacheKey = url + bigScale
      let cached = this.styleCache[cacheKey]
      if (!cached) {
        this.styleCache[cacheKey] = new OlStyleStyle({
          image: new OlStyleIcon({
            src: url,
            anchor: [0.5, 1]
          })
        })
      }
      return this.styleCache[cacheKey]
    },
    tntStyleCounter(feature, resolution, hover) {
      var size = feature.get('features').length
      let url = '/static/img/features/tnt_cluster.png'
      let lbl = size.toString()
      let cacheKey = url + lbl
      let cached = this.styleCache[cacheKey]
      if (!cached) {
        this.styleCache[cacheKey] = new OlStyleStyle({
          image: new OlStyleIcon({
            src: url,
            anchor: [0.5, 1]
          }),
          text: new OlStyleText({
            text: lbl,
            offsetY: -(19 / 2 + 2),
            fill: new OlStyleFill({
              color: '#fff'
            })
          })
        })
      }
      return this.styleCache[cacheKey]
    },
    createLteLayer() {
      let me = this
      let vectorSource = new OlSourceVector({
        format: new GeoJSON(),
        url: this.lteUrl,
        strategy: OlLoadingstrategy.all,
      })
      let clusterSource = new OlSourceCluster({
        distance: 40,
        source: vectorSource
      })
      let layer = new OlLayerVector({
        layerName: 'Lte',
        source: clusterSource,
        style: this.lteStyle,
        visible: true
      })
      return layer
    },
    lteStyle(feature, resolution) {
      var size = feature.get('features').length
      let bigScale = resolution <= 0.000010728836059570312 // TODO voir sur quoi s'appuyer
      if (bigScale || size < 2) {
        return this.lteStylePictos(feature, resolution, false)
      } else {
        return this.lteStyleCounter(feature, resolution, false)
      }
    },
    lteStylePictos(feature, resolution, hover) {
      let bigScale = resolution <= 0.000010728836059570312 // TODO voir sur quoi s'appuyer
      let url = null
      _.forEach(feature.get('features'), realFeat => {
        if (realFeat.get("dateDebut") && realFeat.get("dateDebut") != null && realFeat.get("dateDebut") != "") {
          var date = new Date(realFeat.get("dateDebut"))
          var weekago = new Date()
          weekago.setDate(weekago.getDate() - 7)
          if (date > weekago) {
            url = '/static/img/features/4g_yellow.png'
          } else {
            url = '/static/img/features/4g_blue.png'
          }
        } else {
          url = '/static/img/features/4g_grey.png'
        }
      })
      let cacheKey = url + bigScale
      let cached = this.styleCache[cacheKey]
      if (!cached) {
        this.styleCache[cacheKey] = new OlStyleStyle({
          image: new OlStyleIcon({
            src: url,
            anchor: [0.5, 1]
          })
        })
      }
      return this.styleCache[cacheKey]
    },
    lteStyleCounter(feature, resolution, hover) {
      var size = feature.get('features').length
      let url = '/static/img/features/4g_cluster.png'
      let lbl = size.toString()
      let cacheKey = url + lbl
      let cached = this.styleCache[cacheKey]
      if (!cached) {
        this.styleCache[cacheKey] = new OlStyleStyle({
          image: new OlStyleIcon({
            src: url,
            anchor: [0.5, 1]
          }),
          text: new OlStyleText({
            text: lbl,
            offsetY: -(19 / 2 + 2),
            fill: new OlStyleFill({
              color: '#fff'
            })
          })
        })
      }
      return this.styleCache[cacheKey]
    },
    coordToDegresSexagesimaux(value) {
      let minutes = (value % 1) * 60;
      let secondes = (minutes % 1) * 60;
      return Math.trunc(value) + "° " + Math.abs(Math.trunc(minutes)) + "' " + Math.abs(Math.round(secondes * 1000) / 1000) + "''";
    },
    /**
     * Mise à jour des coordonnées grâce aux données rentrées manuellement par l'utilisateur dans la modale
     */
    updateCoords(coordonnees) {
      // Maj affichage coordonnées
      this.longitude = coordonnees[0];
      this.latitude = coordonnees[1];
      // Transformation des coordonnées entrées en système EPSG:3857 et zoom
      var coords = OlProj.transform(coordonnees, 'EPSG:4326', 'EPSG:3857');
      this.map.getView().setCenter(coords);
    },
    /**
     * Indique si un émetteur TNT a un incident encore non résolu
     * @param incidents La liste des incidents de l'émetteur
     * @return Un booléen
     */
    hasUnresolvedIncident(incidents) {
      return incidents.filter(i => i.statut !== "Résolu").length > 0;
    },
    addExtentListener() {
      // On sauvegarde l'étendue pour une arrivée ultérieure sans position fixée
      this.map.on('moveend', () => {
        this.findLayer('Tnt').getSource().getSource().clear();
        this.findLayer('Lte').getSource().getSource().clear();
        this.findLayer('Tnt').getSource().getSource().refresh();
        this.findLayer('Lte').getSource().getSource().refresh();
        var coords = OlProj.transform(this.map.getView().getCenter(), 'EPSG:3857', 'EPSG:4326');
        this.longitude = coords[0];
        this.latitude = coords[1];
      })
    },
    addLocationTracker(centrer) {
      // Overlay avec le noeud location
      this.marker = new OlOverlay({
        element: document.getElementById('location-marker'),
        positioning: 'bottom-left',
        stopEvent: false
      })
      this.map.addOverlay(this.marker)
      this.geolocation = new OlGeolocation({
        tracking: true,
        trackingOptions: {maximumAge: Infinity, timeout: 1000},
        projection: this.map.getView().getProjection()
      });
      if(centrer){
        this.geolocation.on('change', this.geolocationPositionOnClick.bind(this));
      } else {
        this.geolocation.on('change', this.geolocationPosition.bind(this));
      }

    },
    geolocationPosition(evt){
        // Changement de position : on conserve la valeur
        let p = this.geolocation.getPosition()
        if (p) {
          this.position = p
        }
        this.marker.setPosition(this.position)
        if (this.nextPositionZoomOn) {
          this.nextPositionZoomOn = false
          this.centerOnLocation()
        }
    },
    geolocationPositionOnClick(evt){
        // Changement de position : on conserve la valeur
        let p = this.geolocation.getPosition()
        if (p) {
          this.position = p
        }
        this.marker.setPosition(this.position)
        if (this.nextPositionZoomOn) {
          this.nextPositionZoomOn = false
        }
          this.centerOnLocation()
    },
    createNewGeolocation(){
      this.marker = null
      this.geolocation.un('change', this.geolocationPosition.bind(this))
      this.geolocation = null
      this.addLocationTracker(true)
    }
  }
}
</script>

<style>
.right_content .tools button,
.bottom_right,
.bottom_left button,
.scale *,
.bottom_left .date_maj {
  z-index: 90;
}

.sidebar_button {
  z-index: 91;
}

.top_left,
.search_bar.map_search_bar .icon_location,
.sidebar {
  z-index: 99;
}

.coords {
  background-color: white;
  margin-top: 8px;
  font-weight: bold;
  font-family: Helvetica, Arial;
  padding: 0px;
  color: rgb(50, 50, 50);
  display: flex;
  line-height: 32px;
}

.buttonCoords {
  background-color: #0275d8;
  background-image: url('../../assets/img/icon-gear-white.svg');
  background-size: 60%;
  background-repeat: no-repeat;
  background-position: center center;
  height: 32px;
  width: 32px;
}

.coords p {
  margin: 0 20px 0 10px;
}

.coords .space {
  display: inline-block;
  width: 10px;
}
.outer_center {
  top:50%;
  width:100%;
}

.middle_center {
  z-index: 90;
  display: table;
  margin: 0 auto;
}

.cibleCenter {
  position: relative;
  z-index: 90;
  background-image: url('../../assets/img/cross.png');
  width: 16px;
  height: 16px;
}

#location-marker:before {
  content: "⛳";
  font-size: 1.5em;
  margin-bottom: 0.5em;
  color: #ff002d;
}
</style>
